import { FirestoreError, collection, doc } from "firebase/firestore"
import { firestore } from "../firebase"
import { adminsPath } from "./adminsPath"

const getAdminsRef = () => {
  return collection(firestore, adminsPath.admins);
}

export default getAdminsRef;
